<script lang="ts" setup>
defineProps<{
  description: string
}>()
</script>

<template>
  <div class="relative">
    <SvgIcon class="group-hover:[div]:!opacity-1 !size-6 cursor-pointer !fill-[orange]" name="outlined/info" />

    <div
      class="
        absolute right-0 top-7 min-w-52 rounded-xl border border-solid border-main-gray-low
        bg-white px-2 py-1 text-sm !text-[orange] opacity-0
        transition-all md:text-base
      "
    >
      {{ description }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
svg:hover + div {
  opacity: 1;
}
</style>
